import React, { useState, createContext, useContext, useCallback, useEffect, useRef } from 'react';
import { has, isString } from 'lodash';
import axios from 'axios';
import sjcl from 'sjcl';
import { useConfig } from './config'
// TODO: import settings from '../settings'

const ResponseCode = {};

Object.defineProperties(ResponseCode, {
    Ok : { value: 0 },
    AuthenticationNeeded : { value: -1 },
    AuthenticationExpired : { value: -2 },
    InvalidAuthenticationToken : { value: -3 },
    Unauthorized : { value: -4 },
    EmailTaken : { value: -5 },
    IncompleteInput : { value: -6 },

    DBQueryError : { value: -2000 },
    DBEmptyResult : { value: -2001 },

    UnknownReason : { value: -9999 },
});


let externalSetUser = () => {};
let externalSetToken = () => {};


const axiosRequestInterceptor = (request) => {
    try {
        if (axios.defaults.xdebug) {
            if (request.url.includes('ping.php'))
            {
                if (axios.defaults.xdebugping)
                    console.log('request:', request);
            }
            else {
                console.log('request:', request);
            }
        }
    } catch (err) {

    }
    // let cookieConsentAccepted = false;
    // try {
    //     const item = window.localStorage.getItem(settings.cookieconsent);
    //     cookieConsentAccepted = item ? JSON.parse(item) : false;
    // } catch (error) {
    // }
    //
    // request.headers['X-Cookies-Allowed'] = `${cookieConsentAccepted}`;

    return request;
}


const axiosRequestInterceptorError = (error) => {
    return Promise.reject(error);
}


const requestInterceptorId = axios.interceptors.request.use(axiosRequestInterceptor, axiosRequestInterceptorError);


const axiosResponseInterceptor = (response) => {
    try {
        if (axios.defaults.xdebug) {
            if (response.config.url.includes('ping.php'))
            {
                if (axios.defaults.xdebugping)
                    console.log('response:', response);
            }
            else {
                console.log('response:', response);
            }
        }
    } catch (err) {

    }
    if (has(response, 'data') &&
        has(response.data, 'status'))
    {
        if (response.data.status === ResponseCode.AuthenticationNeeded ||
            response.data.status === ResponseCode.AuthenticationExpired ||
            response.data.status === ResponseCode.InvalidAuthenticationToken)
        {
            window.viewpointselector && window.viewpointselector.close();
            externalSetToken(null);
            externalSetUser(null);
            return ;
        }
    }
    if (has(response, 'headers') &&
        has(response.headers, 'x-auth-token'))
    {
        let authToken = response.headers['x-auth-token'];
        if (/^bearer\x20[^\x20]+$/gi.test(authToken))
            authToken = authToken.substr(7, authToken.length-7);

        externalSetToken(authToken);
    }

    return response;
}


const axiosResponseInterceptorError = (error) => {
    console.error('response error:', error);
    return Promise.reject(error);
}


const responseInterceptorId = axios.interceptors.response.use(axiosResponseInterceptor, axiosResponseInterceptorError);


const pingMS = 10000;


function AuthProvider(props) {

    const [ user, setUser ] = useState(undefined);

    //const [ token, setToken ] = useState(undefined);
    const token = useRef();

    const [ logoutMessage, setLogoutMessage ] = useState("");

    const { apiCallUrl } = useConfig();

    const pingTimerRef = useRef(-1);


    const clearPingTimer = () => {
        if (pingTimerRef.current > -1)
            clearTimeout(pingTimerRef.current)
        pingTimerRef.current = -1;
    }


    useEffect(() => {
        return clearPingTimer;
    }, [])


    const setToken = useCallback((tok) => {

        clearPingTimer();

        token.current = tok;

        if (isString(token.current) && token.current.trim().length > 0) {
        //     axios.defaults.headers.get['Authorization'] = `Bearer ${token.current.trim()}`;
        //     axios.defaults.headers.post['Authorization'] = `Bearer ${token.current.trim()}`;
        //     axios.defaults.headers.patch['Authorization'] = `Bearer ${token.current.trim()}`;
        //     axios.defaults.headers.delete['Authorization'] = `Bearer ${token.current.trim()}`;
        //
            pingTimerRef.current = setTimeout(pinger, pingMS);
        } else {
        //     delete axios.defaults.headers.get['Authorization'];
        //     delete axios.defaults.headers.post['Authorization'];
        //     delete axios.defaults.headers.patch['Authorization'];
        //     delete axios.defaults.headers.delete['Authorization'];
        }
    },[])


    const pinger = useCallback(() => {
        clearPingTimer();

        try {
            axios
                .get(encodeURI(apiCallUrl(`/ping.php`)), {
                    headers : {
                        'Authorization' : `Bearer ${token.current.trim()}`
                    }
                })
                .then((resp) => {
                    console.log(resp.data)
                    if (resp.data.alive) {
                        pingTimerRef.current = setTimeout(pinger, pingMS);
                        return;
                    }

                    setUser(null);
                    setToken(null);
                })
                .catch((err) => {
                    console.log(err)
                })
            ;
        }
        catch (e) {
            console.log(e)
        }
    }, []);


    useEffect(() => {
        externalSetToken = setToken;
        externalSetUser = setUser;
    }, [setUser, setToken]);


    const login = useCallback(async (roleName, password, builder = true) => {
        return new Promise((resolve, reject) => {
            try {
                const hash = sjcl.hash.sha256.hash(password);
                const hashHex = sjcl.codec.hex.fromBits(hash);

                axios.get(encodeURI(apiCallUrl(`/login.php?u=${roleName}&p=${hashHex}`)), {
                        headers:{
                            'Authorization':`Basic login:login`
                        }
                    })
                    .then((resp) => {
                        const { user } = resp.data;

                        let authToken = resp.headers['x-auth-token'];
                        if (/^bearer\x20[^\x20]+$/gi.test(authToken))
                            authToken = authToken.substr(7, authToken.length-7);

                        if (builder) {
                            if (user.administrator || user.projectmanager) {
                                setToken(authToken);
                                setUser({ ...resp.data.user });
                                resolve();
                            }
                            else {
                                setToken(null);
                                setUser(null);
                                reject(-1);
                            }
                        }
                        else {
                            setToken(authToken);
                            setUser({ ...resp.data.user });
                            resolve();
                        }
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err.response);
                    })
                ;
            }
            catch (e) {
                console.log(e)
                reject("Exception in login callback!");
            }
        })
    }, []);


    const logout = useCallback((msg = "") => {
        window.viewpointselector && window.viewpointselector.close();
        setToken(undefined);
        setUser(undefined);
        setLogoutMessage(msg);
    }, []);


    const keepalive = useCallback(() => {
        try {
            axios
                .get(encodeURI(apiCallUrl(`/ping.php?keepalive`)), {
                    headers : {
                        'Authorization' : `Bearer ${token.current.trim()}`
                    }
                })
                .then((resp) => {
                })
                .catch((err) => {
                    console.log(err)
                })
            ;
        }
        catch (e) {
            console.log(e)
        }
    }, []);


    const getProtectedResource = useCallback((url, responseType = 'json') => {
        return axios.get(apiCallUrl(url), {
            headers : {
                'Authorization' : token.current ? `Bearer ${token.current.trim()}` : `Basic login:login`
            },
            responseType
        });
    }, [token]);


    const postProtectedResource = useCallback((url, data) => {
        return axios.post(apiCallUrl(url), data, {
            headers : {
                'Authorization' : `Bearer ${token.current.trim()}`
            }
        });
    }, [token]);


    const postFormDataProtected = useCallback((url, data) => {
        const cfg = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization' : `Bearer ${token.current.trim()}`
            }
        };
        return axios.post(apiCallUrl(url), data, cfg);
    }, [token]);


    const patchProtectedResource = useCallback((url, data) => {
        return axios.patch(apiCallUrl(url), data, {
            headers : {
                'Authorization' : `Bearer ${token.current.trim()}`
            }
        });
    }, [token]);


    const deleteProtectedResource = useCallback((url) => {
        return axios.delete(apiCallUrl(url), {
            headers : {
                'Authorization' : `Bearer ${token.current.trim()}`
            }
        });
    }, [token]);


    return (
        <AuthContext.Provider value={{
            user,
            token:token?.current,
            login,
            logout,
            keepalive,
            getProtectedResource,
            postProtectedResource,
            postFormDataProtected,
            patchProtectedResource,
            deleteProtectedResource
        }} {...props} />
    );
}

const AuthContext = createContext({
    user:null,
    token:null,
    login:null,
    logout:null,
    keepalive:null,
    getProtectedResource:null,
    postProtectedResource:null,
    postFormDataProtected:null,
    patchProtectedResource:null,
    deleteProtectedResource:null
});


const useAuth = () => useContext(AuthContext);


export { AuthProvider, useAuth, ResponseCode }
